<script lang="ts">
	import { assetsUrl } from './shared/assets';

	import VisibilityGuard from './VisibilityGuard.svelte';

	export let image: Image;
	let hasBeenIsVisible = false;
</script>

<VisibilityGuard let:hasBeenIsVisible width="{(image.width / image.height) * 240}px">
	{#if hasBeenIsVisible}
		<picture>
			<img
				src="{assetsUrl}{image.webp}"
				width={image.width}
				height={image.height}
				alt=""
				class="h-60 w-auto"
			/>
		</picture>
	{/if}
</VisibilityGuard>
